module.exports = __webpack_public_path__ + "h5/img/huodong_4.13488137.jpg";